import { createFileRoute } from "@tanstack/react-router";

import { UPCLAIM_ROLES } from "@upclaim/sdk/src/admin-roles";

import { AdminChat } from "@/features/ai-chat/components/admin-chat";
import { useCurrentUser } from "@/hooks/use-current-user";

export const Route = createFileRoute("/_authed/_dashboard/assistant")({
  component: AssistantRoute,
});

/** Assistant plein écran (LLM + outils dossier & datalake) — membres Upclaim et LAWYER. */
function AssistantRoute() {
  const { can } = useCurrentUser();

  if (!can([...UPCLAIM_ROLES, "LAWYER"])) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4">
        <h1 className="text-4xl font-bold">404</h1>
        <p className="text-muted-foreground">Cette page n'existe pas.</p>
      </div>
    );
  }

  return (
    <div className="mx-auto h-[calc(100vh-4rem)] w-full max-w-4xl px-4 py-6 sm:px-6">
      <AdminChat className="h-full" />
    </div>
  );
}
